import { IApplicationState } from '../../types/redux';
import { IPromoPopup } from '../../types/promoPopup';

export const getDiscountMortgagePopup = (state: IApplicationState): IPromoPopup | null | undefined => {
  return state.offersData.discountMortgagePopup;
};
